import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import { AddressManagerCreateActions, UiActions } from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { deparments } from '../../bfpe-common/data/deparments';
import { ApiResponseStatus, StepsNotClientTypes } from 'src/app/shared/enums';
import { urbanizationTypes } from '../../bfpe-common/data/urbanizationTypes';
import { RedirectService } from 'src/app/services/redirect.service';
import { RequestAddressManagerCreate } from 'src/app/shared/interfaces';
import { TagPage } from 'src/app/store/actions/ui.actions';

@Component({
  selector: 'lib-public-address',
  templateUrl: './public-address.component.html',
  styleUrls: ['../../../global.scss', './public-address.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PublicAddressComponent implements OnInit {
  showPanel = false;
  formData: FormGroup;
  departments: any = deparments;
  provinces: any = [];
  districts: any = [];
  urbanizationTypes: any = urbanizationTypes;
  addressManager$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.addressManagerCreate)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private redirectService: RedirectService
  ) {
    this.formData = this._fb.group({
      department: [null, Validators.required],
      province: [null, Validators.required],
      district: [null, Validators.required],
      streetName: ['', Validators.required],
      streetNumber: [''],
      buildingName: [''],
      flatNumber: [''],
      urbanizationType: [null],
      urbanizationName: [''],
      blockNumber: [''],
      lotNumber: [''],
      sectorName: ['', Validators.maxLength(20)]
    });
  }

  addressManagerSuscription = this.addressManager$.subscribe(({ response, error }) => {
    // error case
    if (error != null) {
      this.redirectService.setRedirect(StepsNotClientTypes.STEP_PUBLIC_LANDING);
      this.store.dispatch(AddressManagerCreateActions.cleanState());
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
      this.loadingService.loading = false;
    }
    if (response) {
      this.store.dispatch(AddressManagerCreateActions.cleanState());
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.loadingService.loading = false;
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_INFORMATION_LABOR_CLIENT }));
      } else {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
      }
    }
  });


  ngOnInit() {
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.setService();

    this.formData.get('department').valueChanges.subscribe((val) => {
      if (val) {
        this.provinces = val.provincias;
      }
      this.formData.get('province').patchValue(null);
      this.formData.get('district').patchValue(null);
    });

    this.formData.get('province').valueChanges.subscribe((val) => {
      if (val) {
        this.districts = val.distritos;
      }
      this.formData.get('district').patchValue(null);
    });
  }

  setService() {
    const googleAnalytics = {is_joint_account: this.dataNotClientService.isIsJointAccount()};
    this.store.dispatch(TagPage({text: 'personal-address', extras: googleAnalytics}));
  }

  continue() {
    // Data for all screens
    this.dataNotClientService.setDepartmentCode(this.formData.controls['department'].value.codigo);
    this.dataNotClientService.setDepartmentDescription(this.formData.controls['department'].value.nombre);
    this.dataNotClientService.setProvinceCode(this.formData.controls['province'].value.codigo);
    this.dataNotClientService.setProvinceDescription(this.formData.controls['province'].value.nombre);
    this.dataNotClientService.setDistrictCode(this.formData.controls['district'].value.codigo);
    this.dataNotClientService.setDistrictDescription(this.formData.controls['district'].value.nombre);
    this.dataNotClientService.setStreetName(this.formData.controls['streetName'].value);
    this.dataNotClientService.setStreetNumber(this.formData.controls['streetNumber'].value);
    this.dataNotClientService.setBuildingName(this.formData.controls['buildingName'].value);
    this.dataNotClientService.setFlatNumber(this.formData.controls['flatNumber'].value);
    // OPTIONAL INPUTS
    const urbanizationName = this.formData.controls['urbanizationName'].value;
    const urbanizationType = this.formData.controls['urbanizationType'].value;
    const blockNumber = this.formData.controls['blockNumber'].value;
    const lotNumber = this.formData.controls['lotNumber'].value;
    const sectorName = this.formData.controls['sectorName'].value;
    this.dataNotClientService.setUrbanizationName(urbanizationName ? urbanizationName : null);
    this.dataNotClientService.setUrbanizationType(urbanizationType ? urbanizationType : null);
    this.dataNotClientService.setBlockNumber(blockNumber ? blockNumber : null);
    this.dataNotClientService.setLotNumber(lotNumber ? lotNumber : null);
    this.dataNotClientService.setSectorName(sectorName ? sectorName : null);


    if (this.dataNotClientService.isIsJointAccount()) {
      return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_JOINT_ADDRESS_DATA }));
    } else {
      this.addressRequest();
    }
  }

  openPanel(): void {
    this.showPanel = !this.showPanel;
  }

  addressRequest() {
    const request: RequestAddressManagerCreate = {
      client: {
        regionCode: this.dataNotClientService.getDepartmentCode(),
        regionDescription: this.dataNotClientService.getDepartmentDescription(),
        cityCode: this.dataNotClientService.getProvinceCode(),
        cityDescription: this.dataNotClientService.getProvinceDescription(),
        communeCode: this.dataNotClientService.getDistrictCode(),
        communeDescription: this.dataNotClientService.getDistrictDescription(),
        streetName: this.dataNotClientService.getStreetName()
      }
    };
    if (this.dataNotClientService.getStreetNumber()) {
      request.client.streetNumber = this.dataNotClientService.getStreetNumber();
    }
    if (this.dataNotClientService.getBuildingName()) {
      request.client.buildingName = this.dataNotClientService.getBuildingName();
    }
    if (this.dataNotClientService.getFlatNumber()) {
      request.client.flatNumber = this.dataNotClientService.getFlatNumber();
    }
    if (this.showPanel) {
      if (this.dataNotClientService.getUrbanizationType()) {
        request.client.urbanizationType = this.dataNotClientService.getUrbanizationType();
      }
      if (this.dataNotClientService.getUrbanizationName()) {
        request.client.urbanizationName = this.dataNotClientService.getUrbanizationName();
      }
      if (this.dataNotClientService.getBlockNumber()) {
        request.client.blockNumber = this.dataNotClientService.getBlockNumber();
      }
      if (this.dataNotClientService.getLotNumber()) {
        request.client.lotNumber = this.dataNotClientService.getLotNumber();
      }
      if (this.dataNotClientService.getSectorName()) {
        request.client.sectorName = this.dataNotClientService.getSectorName();
      }
    }

    this.loadingService.loading = true;
    this.store.dispatch(AddressManagerCreateActions.getAddressManagerCreate({ request }));
  }
}
